// 헤더 우측 끝 업체 선택 버튼 (ADMIN.md S3) — 셸(Dashboard.js)이 #dash-header-slot 다음 형제로 렌더한다.
// 라벨: 🏢 {업체명} ▾ / 전체 스코프면 🌐 전체 업체 ▾. 클릭 → CompanyScopeModal (셸이 연다).
// A1(감사) — 주 액션(+ 차량 등록)과 위계가 섞이지 않게 **고스트**(테두리만 · 배경 없음 · 글자 muted, 업체명만 ink)
//   + 좌측 1px 세로 구분선. 구분선은 v2.css `.v2-scope-btn::before` (marginLeft 24 = 구분선 좌우 12px 간격).
//   DOM 은 버튼 하나 그대로 — 셸 헤더의 '우슬롯 다음 마지막 형제' 계약(⑪ 테스트)을 깨지 않는다.
// props: user, isMobile
import React from 'react';
import { T, S, FONT } from '../theme';
import { useCompanyScope } from '../scope';

var btn = Object.assign({}, S.btn, {
  marginLeft: 24, maxWidth: 240, flexShrink: 0,
  background: 'transparent', border: '1px solid ' + T.bd, color: T.muted
});
var btnMob = Object.assign({}, btn, { maxWidth: 148, height: 40, marginLeft: 6 });
var nameSt = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: T.ink, fontWeight: 700 };
var caretSt = { fontSize: FONT.badge, color: T.faint };

function CompanyScopeButton(props) {
  var sc = useCompanyScope(props.user);
  if (!sc.canScope) return null;
  var label = sc.allMode ? '🌐 전체 업체' : ('🏢 ' + (sc.companyName || '업체 선택'));
  return (<button type="button" className="v2-scope-btn" title="업체 선택" aria-label="업체 선택"
    style={props.isMobile ? btnMob : btn} onClick={sc.openPicker}>
    <span style={nameSt}>{label}</span><span style={caretSt}>▾</span>
  </button>);
}

export default CompanyScopeButton;
